import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageDialogData } from '@shared/components/message-dialog/message-dialog-data.model';

import { ModalComponent } from '../modal/modal.component';
import { NoticeComponent } from '../notice/notice.component';

@Component({
  selector: 'stx-message-dialog',
  imports: [ModalComponent, NoticeComponent],
  templateUrl: './message-dialog.component.html'
})
export class MessageDialogComponent {
  data = inject<MessageDialogData>(MAT_DIALOG_DATA);

  get singleMessage(): boolean {
    return this.data.translatedMessages?.length === 1;
  }
}
